<template>

  <div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div key="name" v-if="!hidden" aria-labelledby="modal-title" aria-modal="true" class="fixed z-10 inset-0 overflow-y-auto" role="dialog">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div aria-hidden="true" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span aria-hidden="true" class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

        <div
            class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div class="rounded-t-lg bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="bg-green-100 text-green-700 mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                <slot name="icon"></slot>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <heading><slot name="title"></slot></heading>
                <div class="mt-2 text-sm text-gray-700">
                  <slot name="main"></slot>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 flex flex-col md:px-6 md:flex-row-reverse rounded-b-lg">
            <slot name="buttons">
            </slot>
            <ui-button @click.prevent="closeModal()" colour="gray">
              <i class="fas fa-times-circle mr-1"></i> Cancel
            </ui-button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: 'uimodal'
    },
    preopen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      hidden: true
    }
  },
  computed: {},
  methods: {
    closeModal() {
      this.hidden = true;
    },
    openModal() {
      this.hidden = false;
    }
  },
  mounted() {
    var that = this;
    var key = this.name;
    eventBus.$on('modal-open-' + key, function (closure) {
      that.openModal();
    });
    eventBus.$on('modal-close-' + key, function (closure) {
      that.closeModal();
    });

    if(this.preopen){
      this.openModal();
    }
  }
}
</script>
